/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface BorrowerMinimalNaturalPersonDto
 */
export interface BorrowerMinimalNaturalPersonDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    borrowerId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    phone: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    address: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    civilityId: string;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    birthDate: Date;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalNaturalPersonDto
     */
    firstName: string;
}

/**
 * Check if a given object implements the BorrowerMinimalNaturalPersonDto interface.
 */
export function instanceOfBorrowerMinimalNaturalPersonDto(value: object): value is BorrowerMinimalNaturalPersonDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('borrowerId' in value) || value['borrowerId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    return true;
}

export function BorrowerMinimalNaturalPersonDtoFromJSON(json: any): BorrowerMinimalNaturalPersonDto {
    return BorrowerMinimalNaturalPersonDtoFromJSONTyped(json, false);
}

export function BorrowerMinimalNaturalPersonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerMinimalNaturalPersonDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'borrowerId': json['borrowerId'],
        'type': json['type'],
        'email': json['email'],
        'phone': json['phone'],
        'address': AddressDtoFromJSON(json['address']),
        'civilityId': json['civilityId'],
        'birthDate': (new Date(json['birthDate'])),
        'lastName': json['lastName'],
        'firstName': json['firstName'],
    };
}

export function BorrowerMinimalNaturalPersonDtoToJSON(json: any): BorrowerMinimalNaturalPersonDto {
    return BorrowerMinimalNaturalPersonDtoToJSONTyped(json, false);
}

export function BorrowerMinimalNaturalPersonDtoToJSONTyped(value?: BorrowerMinimalNaturalPersonDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'borrowerId': value['borrowerId'],
        'type': value['type'],
        'email': value['email'],
        'phone': value['phone'],
        'address': AddressDtoToJSON(value['address']),
        'civilityId': value['civilityId'],
        'birthDate': ((value['birthDate']).toISOString().substring(0,10)),
        'lastName': value['lastName'],
        'firstName': value['firstName'],
    };
}

